import styled, { css } from 'styled-components';
import { zIndex, spacing, colors } from 'ui/theme';
import { Help } from 'ui/icons/action/Help';
import { pxToRem } from 'utils/convert';
import { PopoverContent } from './PopoverContent';
import { PopoverPlacements } from './constants';

const POPOVER_PLACEMENT_STYLES = {
  [PopoverPlacements.Top]: css`
    filter: drop-shadow(0px 1px 1px ${colors.grey15});
  `,
  [PopoverPlacements.Bottom]: css`
    filter: drop-shadow(0px -1px 1px ${colors.grey15});
  `,
  [PopoverPlacements.Left]: css`
    filter: drop-shadow(1px 0px 1px ${colors.grey15});
  `,
  [PopoverPlacements.Right]: css`
    filter: drop-shadow(-1px 0px 1px ${colors.grey15});
  `,
};

export const StyledHelpIcon = styled(Help)`
  display: flex;
  &:hover {
    background: ${({ theme }) => theme?.colors?.primaryColors?.purple10};
    border-radius: ${pxToRem(12)};
  }
`;

export const StyledPopoverContent = styled(PopoverContent)<{
  $isInModal: boolean;
  placement: PopoverPlacements;
}>`
  /** if popover content is used in a modal, z-index needs to be updated */
  ${({ $isInModal }) => $isInModal && `z-index: ${zIndex.tooltip};`}
  border: ${spacing.single} solid ${colors.grey15};
  ${({ placement }: { placement: PopoverPlacements }) => POPOVER_PLACEMENT_STYLES[placement]}
`;
